

import React, { useEffect, useState } from "react"

import 'maplibre-gl/dist/maplibre-gl.css';

import MapControls from "../MapControls/MapControl";
import MapComponent from "../MapComponent/MapComponent";
import MapLegend from "../MapLegend/MapLegend"
import { Loading } from "carbon-components-react";
import { camelCase, groupBy } from "lodash";
import { Container, Rectangle, Title, ColorBar, TableWrapper } from "./MapWrapper.styles";
import TrucksTable from "./TrucksTable.container";
import HdopTable from "./HdopTable.container";

const MapWrapper = () => {

    // eslint-disable-next-line 
    const [lastLocations, setLastLocations] = useState([])
    const [timeCategoryCounts, setTimeCategoryCounts] = useState({
        operativo: 0,
        'datos > 15 min': 0,
        'datos > 120 min': 0,
    });
    const [FuelCounts, setFuelLevelCounts] = useState({ 
        mayor500: 0, 
        entre250y500: 0,
        entre0y250: 0 
    });
    // eslint-disable-next-line 
    const [filters, setFilters] = useState({
        patentes: [],
        time_categories: [],
        types: []
    })
    const [tableData, setTableData] = useState([]);
    const [hdopData, setHdopData] = useState([]);

    const [showIcons, setShowIcons] = useState(true);


    const [filteredLayerData, setFilteredLayerData] = useState([])

    const getType = (type) => {
        return camelCase(type)
    }


    useEffect(() => {
        const fetchData = async () => {

            const auth = btoa(`${process.env.REACT_APP_USER}:${process.env.REACT_APP_PASS}`)
            const header = `Basic ${auth}`


            const data = await fetch(`${process.env.REACT_APP_DATA_ENDPOINT}`, {
                method: 'GET',
                headers: {
                    'Authorization': header,
                }
            });

            // const jsonData = await data.json();
            const raw = await data.json()

            const geoJsonTrucks = raw.map((item) => {

                const { lat, lon, type, ...properties } = item


                const cleanedType = getType(type)



                const color = properties.time_category.toLowerCase() === "operativo" ? "blue" : properties.time_category.toLowerCase() === "datos > 15 min" ? "pink" : "red"

                const status = properties.time_category.toLowerCase() === "operativo" ? "#2956d1" : properties.time_category.toLowerCase() === "datos > 15 min" ? "#5c2929" : "#c94b4b"

                let icon = `${color}${cleanedType}`
                if (icon.includes('Tolva')) {

                    icon = icon.replace('Tolva', 'tolva')

                    if (properties.head <= 90) {
                        icon += '45'
                    }
                    else if (properties.head > 90 && properties.head <= 180) {
                        icon += '135';
                    } else if (properties.head > 180 && properties.head <= 270) {
                        icon += '225';
                    } else {
                        icon += '315';
                    }
                } else {
                    icon += properties.head <= 180 ? "E" : "W"
                }


                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [lon, lat]
                    },
                    properties: {
                        icon,
                        type,
                        status,
                        ...properties
                    }
                }
            })

            setLastLocations({
                type: "FeatureCollection",
                features: geoJsonTrucks
            })
        }

        fetchData()
        const interval = setInterval(() => fetchData(), 15000)

        return () => {
            clearInterval(interval)
        }
        // eslint-disable-next-line
    }, [])


    const buildLayers = async () => {

        const filteredData = lastLocations.features?.filter(location => {
            // Filter based on the keys of the filters object

            return (
                (filters.patentes.length > 0 ? filters.patentes.includes(location.properties.truckPatent) : true) &&
                (filters.time_categories.length > 0 ? filters.time_categories.includes(location.properties.time_category) : true) &&
                (filters.types.length > 0 ? filters.types.includes(location.properties.type) : true)
            );
        });
        setFilteredLayerData(filteredData);

        // Extract properties and add unique IDs
        const extractedProperties = filteredData?.map((item, index) => {
            const props = {
                ...item.properties,
                ecu_fuel_level_real: item.properties.ecu_fuel_level_real != null
                    ? parseFloat(item.properties.ecu_fuel_level_real) / 10
                    : null,
                owner: item.properties.owner != null ?item.properties.owner : "Acciona"
            };
        
            return {
                id: `${index + 1}`,
                lat: item.geometry.coordinates[1],
                lon: item.geometry.coordinates[0],
                ...props,
            };
        }) || [];
        setTableData(extractedProperties);

        // Count the trucks in each time_category
        const counts = extractedProperties?.reduce(
            (acc, truck) => {
                const category = truck.time_category;
                if (acc[category] !== undefined) {
                    acc[category]++;
                }
                return acc;
            },
            { operativo: 0, 'datos > 15 min': 0, 'datos > 120 min': 0 }
        );

        // Update state with the counts
        setTimeCategoryCounts(counts);

        const fuelLevelCounts = extractedProperties?.reduce(
            (acc, truck) => {
                const fuelLevel = parseFloat(truck.ecu_fuel_level_real);
        
                if (!isNaN(fuelLevel)) {
                    if (fuelLevel > 50) {
                        acc.mayor500++;
                    } else if (fuelLevel > 25 && fuelLevel <= 50) {
                        acc.entre250y500++;
                    } else if (fuelLevel > 0 && fuelLevel <= 25) {
                        acc.entre0y250++;
                    }
                }
                return acc;
            },
            { mayor500: 0, entre250y500: 0, entre0y250: 0 }
        );
        
        setFuelLevelCounts(fuelLevelCounts);
        
        // Filter data where hdop is above 2
        const hdopFilteredData = extractedProperties?.filter((item) => parseFloat(item.hdop) > 2);
        setHdopData(hdopFilteredData); // Update new state
    };



    useEffect(() => {

        buildLayers()
        // eslint-disable-next-line
    }, [lastLocations, filters])


    useEffect(() => {
    }, [filteredLayerData])

    const toggleIcons = () => {
        setShowIcons(!showIcons)
    }
    return (
        <>
            {lastLocations && lastLocations?.features?.length > 0 ?
                <>

                    <MapControls
                        allItems={lastLocations?.features}
                        filters={filters}
                        setFilters={setFilters}
                        toggleIcons={toggleIcons}
                    />
                    <MapLegend />


                    <MapComponent
                        startingLat={-22.425951072924192}
                        startingLong={-68.84870839535455}
                        startingZoom={11}
                        startingPitch={55}
                        basemap="Satellite"
                        trucksData={filteredLayerData}
                        showIcons={showIcons}
                    />

                    <Container>
                        {timeCategoryCounts && (
                            <>
                                <Rectangle>
                                    <Title>Operativo</Title>
                                    <ColorBar color="rgb(0, 18, 133)">
                                        {timeCategoryCounts.operativo || 0}
                                    </ColorBar>
                                </Rectangle>
                                <Rectangle>
                                    <Title>Datos > 15 min</Title>
                                    <ColorBar color="rgb(201, 75, 75)">
                                        {timeCategoryCounts['datos > 15 min'] || 0}
                                    </ColorBar>
                                </Rectangle>
                                <Rectangle>
                                    <Title>Datos > 120 min</Title>
                                    <ColorBar color="rgb(64, 0, 0)">
                                        {timeCategoryCounts['datos > 120 min'] || 0}
                                    </ColorBar>
                                </Rectangle>
                            </>
                        )}
                    </Container>
                    <Container>
                        {FuelCounts && (
                            <>
                                <Rectangle>
                                    <Title>Combustible sobre 50%</Title>
                                    <ColorBar color="rgb(30, 161, 32)">
                                        {FuelCounts.mayor500 || 0}
                                    </ColorBar>
                                </Rectangle>
                                <Rectangle>
                                    <Title>Combustible sobre 25% hasta 50%</Title>
                                    <ColorBar color="rgb(147, 138, 0)">
                                        {FuelCounts.entre250y500 || 0}
                                    </ColorBar>
                                </Rectangle>
                                <Rectangle>
                                    <Title>Combustible debajo del 25%</Title>
                                    <ColorBar color="rgb(173, 93, 0)">
                                        {FuelCounts.entre0y250 || 0}
                                    </ColorBar>
                                </Rectangle>
                            </>
                        )}
                    </Container>

                    <TableWrapper>
                        <TrucksTable data={tableData} />
                    </TableWrapper>
                    <TableWrapper>
                        <HdopTable data={hdopData} />
                    </TableWrapper>
                </>
                :
                <Loading />
            }
        </>
    )
}

export default MapWrapper